import * as React from 'react';
import ReactTable, { Filter as RTFilter } from 'react-table';
import {connect} from 'react-redux';
import * as FleetModule from 'Modules/FleetModule';
import * as AlertModule from 'Modules/AlertModule';
import {injectThProps, FleetCarBlock, Cell, Filter, IReactTableWrapper} from 'HelperFunctions/Lists';
import {withTranslation} from 'react-i18next';
import {showVehicleList} from 'Redux/Actions/ViewManagementActions';
import {DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_FOR_LIST_VIEW, START_FROM} from "../../constants";
import {InfinityReactTable} from '../common/InfinityReactTable';
import * as UserModule from "Modules/UserModule";
import * as VehiclesModule from "Modules/VehiclesModule";

type P = {
    tableOnly?: boolean;
    match?: any;
    history?: any
    location?: any
};
type ConnectedP = {
    fleetStore: FleetModule.Types.FleetStore
    userRole: UserModule.UserEnumTypes.RoleName
    t?: (key: string) => string;
};
type DispatchedP = {
    getUsersFleet: (params?: URLSearchParams) => Promise<void>;
    setActiveFleet: (fleet: FleetModule.Types.CarFleetDto) => void;
    setActiveRowId: (id: number) => void;
    manageFleet: (type: 'ADD' | 'DELETE', fleet: FleetModule.Types.CarFleetSimpleDto) => void;
    showVehicleList: () => void;
    resetFleetFilteredData: () => void;
    getFleetCars: (fleetId: number) => void;
    searchCarById: (id: string | number) => Promise<void>
};
type S = {
    activeSorting: string;
    activeFilter: string;
    page: number;
    selected: number;
    expanded: Object;
};

class FleetList extends React.PureComponent<P & ConnectedP & DispatchedP, S> implements IReactTableWrapper {
    constructor(props: P & ConnectedP & DispatchedP) {
        super(props);
        this.state = {
            activeSorting: '',
            activeFilter: '',
            page: 0,
            selected: null,
            expanded: {}
        };
        this.getData = this.getData.bind(this);

        this.handleFilterChange = this.handleFilterChange.bind(this)
    }

    public async componentDidMount() {
        this.getData()
        this.props.showVehicleList();

        if (this.props.location?.state?.activeIndex && this.props.fleetStore.fleets) {
            this.handleRowExpanded(undefined, this.props.location?.state?.activeIndex, undefined);
        }
    }

    public componentWillUnmount() {
        if (!this.props.location?.pathname.includes('fleet')) {
          this.props.resetFleetFilteredData()
        }
    }

    private async getData(state?: any, scrolled?: boolean) {
        if (!scrolled && typeof state !== 'undefined') {
          return
        }
        const { params: oldParams, fleets } = this.props.fleetStore
        const first = scrolled ? Number(oldParams.get('first')) + DEFAULT_PAGE_SIZE_FOR_LIST_VIEW : Number(oldParams.get('first'))

        if (fleets.totalCount !== null && fleets.totalCount <= first) {
          return
        }

        const params = new URLSearchParams()

        params.append('first', `${first}`)
        params.append('max', `${DEFAULT_PAGE_SIZE_FOR_LIST_VIEW}`)

        if (oldParams.get('name')) {
          params.append('name', oldParams.get('name'))
        }

        await this.props.getUsersFleet(params);
    }

    private async handleFilterChange(newFiltering: RTFilter[], column: any, value: any) {
        // Na razie wprowadzam filtrowanie tylko po nazwie bo z tego co widzę nie ma innej informacji,
        // po której mogłoby być a skróci to bardzo czas developmentu
        if (column.id === 'name') {
          const params = new URLSearchParams()

          params.append('first', `${START_FROM}`)
          params.append('max', `${DEFAULT_PAGE_SIZE_FOR_LIST_VIEW}`)
          params.append('name', value)

          await this.props.getUsersFleet(params);
        }

    }

    private handleRowExpanded = (newExpanded, index, event) => {
        if (this.state.expanded[index]) {
            this.setState({expanded: {[index]: false}});
            return
        }
        try {
            if (!this.props.fleetStore.activeFleet || this.props.fleetStore.activeFleet.id !== this.props.fleetStore.fleets.results[index].id) {
                this.props.getFleetCars(this.props.fleetStore.fleets.results[index].id);
            }
        } catch (e) {
            console.log(e);
        }

        this.setState({expanded: {[index]: true}});
        if (!this.props.location?.state?.activeIndex || this.props.location?.state?.activeIndex !== index) {
            this.props.history?.replace(this.props.location?.pathname, { activeIndex: index })
        }
    };

    private onFleetClick(fleet: FleetModule.Types.CarFleetSimpleDto) {
        const {match, manageFleet} = this.props;
        if (match.path === '/alerts/add' || match.params.alertId) {
            manageFleet('ADD', fleet);
        }
    }

    private getTrProps = (state: any, rowInfo: any) => {
        return {
            onClick: () => {
                this.setState({selected: rowInfo.index});
                this.onFleetClick(rowInfo.original);
                this.props.setActiveRowId(rowInfo.original.id);
            },
            className: rowInfo && rowInfo.index === this.state.selected ? 'active' : ''
        };
    };

    private prepareAdditionalProps() {
      if ([UserModule.UserEnumTypes.RoleName.FLEET_OWNER, UserModule.UserEnumTypes.RoleName.EXTERNAL].includes(this.props.userRole)) {
        return {
          hasAccessToDiagnostic: true,
          onClick: this.props.searchCarById
        }
      }

      return {}
    }

    public render() {
        const {
          fleetStore,
          t,
          tableOnly,
        } = this.props;
        let pages = fleetStore.fleets ? Math.ceil(fleetStore.fleets.totalCount / DEFAULT_PAGE_SIZE) : 1;
        let data = fleetStore.fleets?.results || []
        let total = fleetStore.fleets?.totalCount || 0
        let pageSize = fleetStore.fleets.results.length < fleetStore.fleets.max
          ? fleetStore.fleets.results.length
          : fleetStore.fleets.max
        if (fleetStore.fleetsFiltered) {
          pages = Math.ceil(fleetStore.fleetsFiltered.totalCount / DEFAULT_PAGE_SIZE)
          data = fleetStore.fleetsFiltered.results
          total = fleetStore.fleetsFiltered.totalCount
          pageSize = fleetStore.fleetsFiltered.results.length < fleetStore.fleetsFiltered.max
            ? fleetStore.fleetsFiltered.results.length
            : fleetStore.fleetsFiltered.max
        }

        const nameParam = fleetStore.params?.get('name')
        const defaultFiltered = fleetStore.params?.get('name')
          ? [{ value: nameParam, id: 'name' }]
          : undefined

        const fleetTable = (
            <InfinityReactTable
                // className="reactTable vehicleList--table vehicleList--nomaxheight fleetList"
                data={data}
                dataLength={total}
                filterable
                defaultFiltered={defaultFiltered}
                expanded={this.state.expanded}
                pageSize={pageSize}
                // page={this.state.page}
                getTheadThProps={injectThProps}
                defaultPageSize={DEFAULT_PAGE_SIZE}
                getTrProps={this.getTrProps}
                onExpandedChange={this.handleRowExpanded}
                SubComponent={() => <FleetCarBlock fleetDto={fleetStore.activeFleet} {...this.prepareAdditionalProps()} />}
                // onPageChange={page => this.setState({page})}
                onFetchData={this.getData}
                onFilteredChange={this.handleFilterChange}
                columns={this.columnsConf}
                manual
            />
        );

        if (!tableOnly) {
            return (
              <div className="main__content main__content--no-padding">
                <div className="table__content" data-testid="fleet-table">
                  {fleetTable}
                </div>
                <div className="table__footer">
                  <div>
                    {data.length} z {total}
                  </div>
                </div>
              </div>
            );
        } else {
          return fleetTable;
        }
    }

  private creationDateFilter = Filter.SortFilter.bind(this, this.props.t('creationDate'));

  private columnsConf = [
    {
      expander: true,
      Header: 'hiddenHeader',
      className: 'cell',
            width: 65,
            Expander: Cell.Expander
        },
        {
            Header: 'hiddenHeader',
            id: 'name',
            headerClassName: 'text-left',
            className: 'cell',
            accessor: 'name',
            Filter: (filterInfo: any) => Cell.RegularFilter(filterInfo, this.props.t('fleetName'), 'filter__input--fleet'),
            Cell: Cell.Fleet
        },
        {
            Header: 'hiddenHeader',
            id: 'creationDate',
            className: 'cell',
            accessor: 'creationDate',
            width: 150,
            Filter: this.creationDateFilter,
            Cell: Cell.Date
        }
    ];

    // możliwość dodania do wszystkich kolumn np. dodatkowej klasy 'headerClassName'
    // private decorateColumns(cols, key, val) {
    //         return cols.map(col => col[key] = val);
    // }

    public setActiveSorting(e: any, colId: string, onChange: Function) {
        this.setState({
                activeSorting: colId
            }, () => onChange(e)
        );
    }
}

function mapStateToProps(state: any): ConnectedP {
    return {
        fleetStore: state.fleetStore,
        userRole: state.userStore.user?.roleName,
    };
}


function mapDispachToProps(dispatch: any): DispatchedP {
    return {
        getUsersFleet: (params) => dispatch(FleetModule.Actions.getUsersFleet(params)),
        setActiveFleet: (fleet: FleetModule.Types.CarFleetDto) => dispatch(FleetModule.Actions.setActiveFleet(fleet)),
        setActiveRowId: (id: number) => dispatch(FleetModule.Actions.setActiveRowId(id)),
        manageFleet: (type: 'ADD' | 'DELETE', fleet: FleetModule.Types.CarFleetSimpleDto) => dispatch(AlertModule.Actions.manageFleet(type, fleet)),
        showVehicleList: () => dispatch(showVehicleList()),
        resetFleetFilteredData: () => dispatch(FleetModule.Actions.resetFleetFilteredData()),
        getFleetCars: (fleetId: number) => dispatch(FleetModule.Actions.getFleetById(fleetId)),
        searchCarById: (id: string | number) => dispatch(VehiclesModule.Actions.searchCarById(id))
    };
}

export default withTranslation('carDetails')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(FleetList) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Fleet/FleetList.tsx